import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { ChevronLeft } from 'lucide-react'
import { links } from 'utils/featureToggles'

import ConfirmationModal from '../../../components/ConfirmationModal/ConfirmationModal'
import { PaymentProviderTab } from './PaymentProviderSlug'

export const PaymentProviderNavigation = ({
  isEdit,
  setEdit,
}: {
  isEdit: boolean
  setEdit: React.Dispatch<React.SetStateAction<boolean>>
}): JSX.Element => {
  const navigate = useNavigate()
  const params = useParams<{
    id: string
    slug: string
  }>()

  const [confirmationModal, setConfirmationModal] = useState<boolean>(false)
  const [keyToChange, setKeyToChange] = useState<string>('')

  const handleTabClick = (key: string) => {
    setKeyToChange(key)

    if (isEdit) {
      setConfirmationModal(true)
    } else {
      navigate(`../${key}`, { relative: 'path' })
    }
  }

  const handleTabChange = (reason: boolean) => {
    if (reason) {
      setEdit(false)
      navigate(`../${keyToChange}`, { relative: 'path' })
    }
    setConfirmationModal(false)
  }

  const handleBackButton = () => {
    navigate(links.administrationPaymentProvidersConfig.url)
  }

  return (
    <div>
      <ConfirmationModal
        contentText='The page is asking you to confirm that you want to leave - data you have entered may not be saved.'
        yesButtonText='Leave Page'
        cancelButtonText='Stay on page'
        onYes={() => handleTabChange(true)}
        onCancel={() => handleTabChange(false)}
        visible={confirmationModal}
      />

      <header>
        <Button variant='outline' size='icon' onClick={handleBackButton}>
          <ChevronLeft />
        </Button>
      </header>

      <Tabs value={params.slug} onValueChange={handleTabClick} className='mt-2'>
        <TabsList>
          <TabsTrigger value={PaymentProviderTab.OPTIONS_AND_LIMIT}>Options & Limits</TabsTrigger>

          <TabsTrigger value={PaymentProviderTab.COUNTRIES}>Countries</TabsTrigger>

          <TabsTrigger value={PaymentProviderTab.LANGUAGES}>Languages</TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  )
}
